import React from 'react';
import {connect} from 'react-redux';

import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';

class Contacts extends React.Component {
    render() {
        return <FullWidthPage title="Контакти">
            <div className="col-md-12">
                <SectionTitle>Свържи се с нас</SectionTitle>
                <p>Ако искате да ни попитате нещо, пишете ни имейл (<a href="mailto:hi@medita.bg">hi@medita.bg</a>), на Фейсбук или през чата на сайта.</p>
            </div>
        </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(Contacts);




// WEBPACK FOOTER //
// ./src/components/Pages/Contacts.js